import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

import Button from '../../../../../../components/global/Button';

const propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  linkTo: PropTypes.string,
  icon: PropTypes.node,
  count: PropTypes.number,
  label: PropTypes.string,
};

const WebGalleryActionBarButton = ({
  linkTo,
  onClick,
  icon,
  className,
  count,
  label,
  ...props
}) => {
  const classes = classNames({
    'web-gallery-action-bar-button': true,
    [className]: !!className,
  });
  return (
    <>
      <Button
        onClick={onClick}
        to={linkTo}
        {...props}
        className={classes}
        data-place="bottom"
        data-for={label}
        data-tip={label}
      >
        {icon}

        {count > 0 && (
          <div className="web-gallery-action-bar-button-count">{count}</div>
        )}

        {label && (
          <ReactTooltip
            className="tooltip"
            globalEventOff="click"
            effect="solid"
            id={label}
          />
        )}
      </Button>
    </>
  );
};

WebGalleryActionBarButton.propTypes = propTypes;

export default WebGalleryActionBarButton;
